module.exports = __webpack_public_path__ + "static/media/41-1.360c0426.mp3";